import { IsNotEmpty } from "class-validator";
import { DataValidationError } from "constants/DataValidationError";

export default class DeleteCastShiftReq {
  @IsNotEmpty({
    message: DataValidationError.DATA_IS_EMPTY,
  })
  readonly castShiftId: number;

  constructor(arg: any) {
    arg = arg || {};
    this.castShiftId = arg.castShiftId;
  }
}
